<template>
  <DataItem
    v-if="props.data?.hide !== true"
    :loading="props.loading"
    :label="props.data?.type"
    :value="props.data?.name"
    valueClass="text-xl sm:text-2xl"
    col-span-2
    sm:col-span-1
  />
</template>
<script setup>
const props = defineProps(["loading", "data"]);
</script>
